import { PropTypes } from "prop-types";
import React from "react";

import { Text, textPropTypes } from "@swa-ui/core";
import i18n from "@swa-ui/locale";

import { getStationNameAndState } from "../Stations";

export const TripOriginDestinationBoundDetail = (props) => {
  const { destinationAirportCode, originAirportCode, showAirportCodes, textProps } = props;

  return (
    <Text {...getTextProps()}>
      <Text {...getAirportTextProps()}>{getStationNameAndState(originAirportCode)}</Text>
      {showAirportCodes && originAirportCode && (
        <Text {...getAirportTextProps()}>{` (${originAirportCode}) `}</Text>
      )}
      <Text {...getSeparatorTextProps()}>{` ${i18n("TripOriginDestinationDetail__TO")} `}</Text>
      <Text {...getAirportTextProps()}>{getStationNameAndState(destinationAirportCode)}</Text>
      {showAirportCodes && (
        <Text {...getAirportTextProps()}>{` (${destinationAirportCode}) `}</Text>
      )}
    </Text>
  );

  function getTextProps() {
    return {
      element: "span",
      size: "xsmall",
      textType: "display",
      ...textProps,
    };
  }

  function getAirportTextProps() {
    return {
      bold: true,
      element: "span",
    };
  }

  function getSeparatorTextProps() {
    return {
      element: "span",
      italics: true,
    };
  }
};

TripOriginDestinationBoundDetail.propTypes = {
  /** Airport code for the arrival airport. */
  destinationAirportCode: PropTypes.string.isRequired,

  /** Airport code for the departure airport. */
  originAirportCode: PropTypes.string.isRequired,

  /** Indicates where the airport codes should be displayed. */
  showAirportCodes: PropTypes.bool,

  /** Props passed to the underlying Text component. See Text for more details. */
  textProps: PropTypes.shape(textPropTypes),
};
